import _extends from "@babel/runtime/helpers/esm/extends";
import React, { forwardRef } from 'react';
import { typedMemo } from '../../utils';
import { StyledForm } from './styled';
import { FormContext } from './useFormContext';
const StyleableForm = _ref => {
  let {
    forwardedRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement(FormContext.Provider, {
    value: {
      fullWidth: props.fullWidth
    }
  }, /*#__PURE__*/React.createElement(StyledForm, _extends({}, props, {
    ref: forwardedRef
  })));
};
export const Form = typedMemo( /*#__PURE__*/forwardRef((_ref2, ref) => {
  let {
    className,
    style,
    ...props
  } = _ref2;
  return /*#__PURE__*/React.createElement(StyleableForm, _extends({}, props, {
    forwardedRef: ref
  }));
}));